import { FirebaseAuthConsumer } from "@react-firebase/auth";
import Login from "./Login";
import AdminPanel from "./AdminPanel";
import { toUpper } from "lodash";
import queryString from "query-string";
import GetToken from "./GetToken";
import styled from "@emotion/styled";

const Header = styled.div({
  width: '100%',
  background: '#334',
  textAlign: 'center',
  color: '#eee',
  boxShadow: 'rgba(0,0,0,0.2) 0px 0px 10px',
})

function App() {
  const env = process.env.REACT_APP_ENVIRONMENT ?? "local";

  const urlParams = queryString.parse(window.location.search, {
    parseBooleans: true,
  });
  
  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'stretch', minHeight: '100vh',  }}>
      <Header>
        <h2>{`This is ${toUpper(env)} admin panel`}</h2>

        <p>
          In order for this tool to work you must have an admin role added
        </p>
      </Header>
      <FirebaseAuthConsumer>
        {({ isSignedIn, user }) =>
          isSignedIn ? (
            urlParams.getToken ? (
              <GetToken user={user} />
            ) : (
              <AdminPanel user={user} />
            )
          ) : (
            <Login />
          )
        }
      </FirebaseAuthConsumer>
    </div>
  );
}

export default App;
